// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.video-background {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }
  
  video {
    width: 100%;
    height: 100%;
    object-fit: cover; 
    display: block;
  }
  
  .video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); 
    display: flex;
    justify-content: center;
    align-items: center;
    /* text-align: center; */
    color: #fff;
  }
  
  .welcome-text h1 {
    font-size: 3.5rem;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .welcome-text p {
    font-size: 1.2rem;
    margin-bottom: 30px;
    line-height: 1.6;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .sign-up-btn {
    background-color: #2596be;
    color: white;
    padding: 12px 30px;
    font-size: 18px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .sign-up-btn:hover {
    background-color: #007b8f;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/VideoBackground.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":["\n.video-background {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    overflow: hidden;\n  }\n  \n  video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover; \n    display: block;\n  }\n  \n  .video-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5); \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* text-align: center; */\n    color: #fff;\n  }\n  \n  .welcome-text h1 {\n    font-size: 3.5rem;\n    font-weight: bold;\n    margin-bottom: 20px;\n  }\n  \n  .welcome-text p {\n    font-size: 1.2rem;\n    margin-bottom: 30px;\n    line-height: 1.6;\n    max-width: 800px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  .sign-up-btn {\n    background-color: #2596be;\n    color: white;\n    padding: 12px 30px;\n    font-size: 18px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .sign-up-btn:hover {\n    background-color: #007b8f;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
